export { default as EthicalGovernanceView } from "./EthicalGovernanceView";
